//api.js
import service from "./index";
export const userApi = {
  getNoticeList(params) {
    return service({
      url: "activitylist",
      method: "get",
      params
    });
  },
  getactivityDeatil(params) {
    return service({
      url: "activitydetail",
      method: "get",
      params
    });
  },
  getnewList(params) {
    return service({
      url: "newslist",
      method: "get",
      params
    });
  },
  getnewDeatil(params) {
    return service({
      url: "newsdetail",
      method: "get",
      params
    });
  },
  getpartyList(params) {
    return service({
      url: "partylist",
      method: "get",
      params
    });
  },
  getpartyDeatil(params) {
    return service({
      url: "partydetail",
      method: "get",
      params
    });
  },
  // 人事的接口
  getpersonList(params) {
    return service({
      url: "personnellist",
      method: "get",
      params
    });
  },
  getpersonDeatil(params) {
    return service({
      url: "personneldetail",
      method: "get",
      params
    });
  },
  // 期刊的列表
  getjournallistList(params) {
    return service({
      url: "journallist",
      method: "get",
      params
    });
  },
  getjournalDetail(params) {
    return service({
      url: "journaldetail",
      method: "get",
      params
    });
  },
  getjournalperiod(params) {
    return service({
      url: "journalperiod",
      method: "get",
      params
    });
  },
  // 业务工作列表
  workList(params) {
    return service({
      url: "workslist",
      method: "get",
      params
    });
  },
  //详情
  workDetail(params) {
    return service({
      url: "worksdetail",
      method: "get",
      params
    });
  },
  // 侧边栏
  workperiod(params) {
    return service({
      url: "works",
      method: "get",
      params
    });
  },
  //组织机构图
  department(params) {
    return service({
      url: "department",
      method: "get",
      params
    });
  },
  // 组织机构的
  organizationdetail(params) {
    return service({
      url: "organizationdetail",
      method: "get",
      params
    });
  },
  //友情链接
  getFriendLink(params) {
    return service({
      url: "links",
      method: "get",
      params
    });
  },
  //科研工作列表接口

  cooperationList(params) {
    return service({
      url: "cooperationlist",
      method: "get",
      params
    });
  },
  cooperationDetail(params) {
    return service({
      url: "cooperationdetail",
      method: "get",
      params
    });
  },
    // 联系我们
    conDetail() {
      return service({
        url: "contactus",
        method: "get"
      });
    },
    // banqunasming
    statement() {
      return service({
        url: "copyright",
        method: "get"
      });
    },
    multipleinfo(params) {
      return service({
        url: "multipleinfo",
        method: "get",
        params
      });
    },
    // 党建接口
  getBuildingList(params) {
    return service({
      url: "dangjianlist",
      method: "get",
      params
    });
  },
    getBuildingSwiper(params) {
      return service({
        url: "djlist",
        method: "get",
        params
      });
    },
    getBuildingdetail(params) {
      return service({
        url: "dangjiandetail",
        method: "get",
        params
      });
    },
};



// WEBPACK FOOTER //
// ./src/api/user.js